import {CommonDataTableFields, GroupSortableColumnsDictionary} from '../types';

export const GroupSortableTrendColumns: GroupSortableColumnsDictionary = {
  [CommonDataTableFields.Average]: {sortSelectTitle: `Average`},
  [CommonDataTableFields.LiftAverage]: {sortSelectTitle: `Average`},
  [CommonDataTableFields.Sum]: {sortSelectTitle: `Sum`},
  [CommonDataTableFields.LiftSum]: {sortSelectTitle: `Sum`},
  [CommonDataTableFields.Min]: {sortSelectTitle: `Min`},
  [CommonDataTableFields.LiftMin]: {sortSelectTitle: `Min`},
  [CommonDataTableFields.Max]: {sortSelectTitle: `Max`},
  [CommonDataTableFields.LiftMax]: {sortSelectTitle: `Max`},
  [CommonDataTableFields.Median]: {sortSelectTitle: `Median`},
  [CommonDataTableFields.LiftMedian]: {sortSelectTitle: `Median`},
};
// If we add cohort size as a column (it is currently hidden), we could add it to GroupSortableTrendColumns and remove this constant
export const GroupSortableTrendFields = [...Object.keys(GroupSortableTrendColumns), CommonDataTableFields.CohortSize];
